<template>
  <v-dialog v-model="isOpenDialog" width="40%" class="dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" flat class="pa-3">
        <div class="d-flex">
          <v-col cols="6" md="6" class="pb-0">
            <v-autocomplete
              v-model="group"
              clear-icon="mdi-close"
              :items="groups"
              item-text="title"
              item-value="id"
              :label="`${type === 'normal' ? 'Nhóm chịu phí' : 'Nhóm giảm trừ'}`"
              :loading="loading"
              clearable
              outlined
              dense
              return-object
              required
              :rules="[$rules.required]"
            >
            </v-autocomplete>
          </v-col>
        </div>
      </v-form>
      <div class="py-10"></div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined class="my-2" width="100" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn
          depressed
          class="my-2"
          width="100"
          :loading="loading"
          :disabled="isDisable"
          color="primary"
          @click="choice"
        >
          Chọn
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { TuitionFeeGroup } from '@/plugins/api'

export default {
  props: {
    type: String
  },
  data() {
    return {
      isOpenDialog: false,
      title: '',
      isDisable: true,
      rule: this.$rules.required,
      groups: [],
      group: {},
      loading: false
    }
  },
  computed: {
    titleDialog() {
      if (this.type === 'normal') return 'CHỌN NHÓM ĐỐI TƯỢNG CHỊU PHÍ'
      else return 'CHỌN NHÓM ĐỐI TƯỢNG GIẢM TRỪ'
    }
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['fetchAll']),
    cancel() {
      this.isOpenDialog = false
      this.$refs.form.reset()
    },
    async choice() {
      this.$emit('choice-group', this.group)
      this.isOpenDialog = false
    },
    openDialog() {
      this.isOpenDialog = true
    }
  },
  watch: {
    async type() {
      if (this.type) {
        this.loading = true
        this.groups = await TuitionFeeGroup.fetch({ type: this.type })
        this.loading = false
      }
    },
    group() {
      if (this.group && this.group.title) {
        this.isDisable = false
      }
    }
  }
}
</script>
